
import { computed, defineComponent } from 'vue';
import AppMenuItem from '@/modules/main/menu-sidebar/menu-item.vue';
import { menuRegistry } from '@/common/menu/menuRegistry';
import { useAuthStore } from '@/modules/auth/store';
import { storeToRefs } from 'pinia';

export default defineComponent({
    name: 'AppMenuSidebar',
    components: { AppMenuItem },
    setup() {
        const { sysRoles } = storeToRefs(useAuthStore());

        const sidebarSkin = process.env.VUE_APP_SIDEBAR_SKIN;
        const menuTree = computed(() => menuRegistry.buildMenuTree(sysRoles.value));

        return { sidebarSkin, menuTree };
    }
});
